import * as types from "./actionTypes";
import redirector from "../util/redirector";

export function throwException(exception, redirectToExceptionPage = false) {
	if(exception.toString().indexOf("401") > -1)
	{
		redirector.goToNoAccessPage();
	}
	return {
		type: types.THROW_EXCEPTION,
		body: {
			exception,
			redirectToExceptionPage
		}
	};
}

export function clearException() {
	return {
		type: types.CLEAR_EXCEPTION
	};
}
